var _style, _path, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSjIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 32",
    width: 37,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sj_icon-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #e2e2e2 } \n\t\t.txt1 { font-size: 28px;fill: #b8b8b8;font-weight: 700;font-family: \"IBMPlexSans-Bold\", \"IBM Plex Sans\" } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M-2 -14L49 -14L49 46L-2 46C-2.92 46 -3.83 45.82 -4.68 45.47C-5.53 45.12 -6.3 44.6 -6.95 43.95C-7.6 43.3 -8.12 42.53 -8.47 41.68C-8.82 40.83 -9 39.92 -9 39L-9 -7C-9 -7.92 -8.82 -8.83 -8.47 -9.68C-8.12 -10.53 -7.6 -11.3 -6.95 -11.95C-6.3 -12.6 -5.53 -13.12 -4.68 -13.47C-3.83 -13.82 -2.92 -14 -2 -14L-2 -14Z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SJ",
    style: {
      transform: "matrix(1,0,0,1,3,27)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "txt1"
  }, "SJ\n")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSjIcon);
export default __webpack_public_path__ + "static/media/sj_icon.70b485047de3d163006e792f9d08fa51.svg";
export { ForwardRef as ReactComponent };